// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"_3NZc4cij72ZiroI1RAWSJw","additionalContent":"_3BDVFOasheD6N8UTIb4Tnh","showInCombo":"UXGmxpcxbIbJPhhtmc40B","externalId":"_2tVlqAgP5khS_qWEfPOhG5"};